import {DefaultFoundationTheme, ThemeColorPath} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {Nullish} from 'shared/web';

import {getThemeToken} from './getThemeToken';

/**
 * Calendar events and user chips are colored per user with raw #RRGGBB values (Google
 * Calendar palette), while other calendar consumers keep using theme color paths.
 * Resolves both forms to a CSS color — hex support stays local to big-calendar instead
 * of widening the platform color primitives.
 */
export const resolveCalendarColor = (
  color: ThemeColorPath | string | Nullish,
  theme: DefaultFoundationTheme
): string =>
  match(color)
    .with(Pattern.nullish, () => '')
    .with(Pattern.string.startsWith('#'), (hexColor) => hexColor)
    .otherwise((themeColorPath) => getThemeToken<string>(theme, `colors.${themeColorPath}`));
